import React from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import PrivacyPolicy from './PrivacyPolicy';

import BasePage from '@ts-core/pages/BasePage';

import logoSmall from '@ts-core/img/logoSmall.svg';

const TermsAndConditionsPage = () => {
  const location = useLocation();

  const query = queryString.parse(location.search);
  const { embedMode } = query;

  return (
    <Box>
      {!embedMode && (
        <Box width="100%" height={{ xs: 56, md: 64 }}>
          <AppBar position="fixed" color="default" elevation={1}>
            <Toolbar>
              <img src={logoSmall} alt="logo" />
            </Toolbar>
          </AppBar>
        </Box>
      )}
      <BasePage>
        <Typography variant="h4" gutterBottom>
          Política de privacidad
        </Typography>
        <PrivacyPolicy />
      </BasePage>
    </Box>
  );
};

export default TermsAndConditionsPage;
